import styled from "styled-components";
import ButtonOutlined from "../../../common/components/Buttons/ButtonOutlined";
import Card from "../../../common/components/Card/Card";
import Icon from "../../../common/components/Icon/Icon";
import { getParagraph16BoldTypography } from "../../../common/Typography";
import { Paragraph12Regular } from "../../../common/Typography/Paragraph12";
import Typography from "../../../common/components/Typography/Typography";
import { FormControl } from "../../../common/components/FormControls";

export const FileUploadFormControl = styled(FormControl)`
  margin-bottom: 20px;
  margin-top: 8px;
`;

export const FormCard = styled(Card)`
  min-height: 90px;
`;

export const StyledFileUploadProgress = styled(FormCard)`
  display: flex;
  flex-direction: row;
  align-items: center;

  div {
    flex-grow: 1;
    margin-right: 24px;

    div {
      display: flex;
      flex-grow: 0;
      justify-content: space-between;
      margin-right: 0;
      margin-top: 6px;
      margin-bottom: 6px;
    }
  }
`;

export const Right = styled.div`
  word-wrap: break-word;
  white-space: pre-wrap;
  position: relative;

  button {
    flex-grow: 1;
  }
`;

export const FileUploadContainer = styled(FormCard)<{
  isImage: boolean;
  $isDragging?: boolean;
  $unknown?: boolean;
  $valid?: boolean;
  $invalid?: boolean;
  $error?: boolean;
}>`
  display: flex;
  color: ${(props) => props.theme.primaryColor};
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  border: 1px
    ${({ $unknown, $valid, $invalid, $error, theme }) =>
      $unknown
        ? theme.primaryColor
        : $valid
        ? theme.greenColor
        : $invalid || $error
        ? theme.errorColor
        : "transparent"};
  border-style: ${({ $isDragging }) => ($isDragging ? "dashed" : "solid")};

  div {
    display: flex;
  }
  .left {
    flex-direction: column;

    div {
      margin-top: 8px;
    }
  }
`;

export const FormatBadge = styled.div`
  border: 2px solid ${(props) => props.theme.badgeBorderColor};
  border-radius: ${(props) => props.theme.borderRadius.sm};
  color: ${(props) => props.theme.greyColor};
  width: fit-content;
  padding: 3px 5px;
`;

export const SecondaryText = styled(Paragraph12Regular)`
  color: ${(props) => props.theme.greyColor};
`;

export const StyledBrowseFilesButton = styled(ButtonOutlined)`
  border: 2px solid ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.primaryColor};
  ${getParagraph16BoldTypography};
  position: relative;
  white-space: nowrap;
`;

export const StyledFileInput = styled.input`
  cursor: pointer;
  position: absolute;
  /* Hiding the tap color when it is clicked on touch devices ( this is not widely supported ) */
  -webkit-tap-highlight-color: transparent;
  opacity: 0;
  width: 1000px;
  height: 300px;
`;

export const FileFieldError = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FileFieldErrorText = styled(Typography)`
  color: ${(props) => props.theme.errorColor};
`;

export const FileInputSuccess = styled(FormCard)`
  color: ${(props) => props.theme.greenColor};
  border: 2px solid ${(props) => props.theme.greenColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;

    svg {
      margin-right: 19px;
    }

    .details {
      display: flex;
      flex-direction: column;

      ${FormatBadge} {
        color: ${(props) => props.theme.greenColor};
        border: 2px solid ${(props) => props.theme.greenColor};
        margin-top: 6px;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column-reverse;
    position: relative;

    .left {
      flex-direction: column-reverse;

      svg {
        margin-right: 0;
      }

      .details {
        p {
          margin-bottom: 8px;
          text-align: center;
        }
        ${FormatBadge} {
          position: absolute;
          top: 0;
          left: 10px;
        }
      }
    }
    button {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
`;

export const UploadDetails = styled.div`
  max-width: 455px;
`;

const StyledCancelButton = styled.button`
  background: ${(props) => props.theme.lightBackgroundColor};
  border-radius: 40px;
  width: 32px;
  height: 32px;
  padding: 4px;
`;

export const CancelButton = ({ onClick }: { onClick: () => void }) => (
  <StyledCancelButton onClick={onClick} type="button">
    <Icon name={"cancel"} width="14px" />
  </StyledCancelButton>
);
